<template>
  <user-course-register>
    <template v-slot:step3>
      <v-card flat>
        <v-card-text class="py-0 px-0">
          <v-row>
            <v-col cols="12" sm="12" md="3" v-if="courseHasModules" class="pt-0">
              <v-list class="pt-0 v-list-modules">
                <v-subheader class="ml-1">Módulos</v-subheader>
                <div class="text-center" v-if="loadingModules">
                  <v-progress-linear indeterminate></v-progress-linear>
                  Carregando módulos

                </div>
                <v-list-item-group v-model="moduleSelect" color="primary">
                  <v-list-item
                    ripple
                    v-for="(module, $index) in modules"
                    :key="$index"
                    @click="selectModule(module._id)"
                    ref="modulesCourse"
                    class="py-1"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="module.title"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>

            <v-col cols="12" sm="12" md="9" class="pt-0">
              <div class="text-center mt-5" v-if="loadingContent">
                <v-progress-linear indeterminate></v-progress-linear>
                Carregando conteúdo
              </div>
              <div v-else>
                <v-alert class="mt-0 white-text" :value="courseHasModules && !moduleId" type="warning">
                  Selecione o módulo
                </v-alert>

                <v-card flat v-if="!courseHasModules || !!moduleId">

                  <v-card-title class="pl-0" v-if="moduleTitle">
                    <h4>{{ moduleTitle }}</h4>
                  </v-card-title>

                  <v-card-text class="pl-0 pr-0 btns-add">

                    <v-btn rounded color="primary" @click="addContent(1)">
                      <v-icon>add</v-icon>
                      Adicionar vídeo
                    </v-btn>

                    <v-btn rounded color="primary" @click="addContent(2)">
                      <v-icon>add</v-icon>
                      Adicionar texto
                    </v-btn>

                  </v-card-text>

                  <v-card-text class="pl-0 thumbs-content">
                    <div class="pt-0">
                      <draggable v-model="contentsLocal" class="layout wrap row mt-3" @end="onEnd" @update="onUpdate"
                                 :options="draggableOptions">

                        <v-col class="" cols="12" xs="12" sm="6" md="4" lg="3"
                               v-for="(content, $index) in contentsLocal"
                               :key="$index">
                          <v-badge
                            color="primary"
                            :content="content.position + 1"
                            overlap>

                            <!-- <template v-if="content.vimeoId">
                              <v-icon class="play-badge" color="white" v-if="content.type === 1">play_arrow</v-icon>
                            </template>
                            <v-icon color="white" v-if="content.type === 2">text_fields</v-icon> -->

                            <v-card>
                              <v-img class="video-thumb-content" v-if="content.thumb" :src="content.thumb"
                                     aspect-ratio="2"></v-img>
                              <div v-else>
                                <div class="video-thumb" v-if="content.type === 1">
                                  <v-icon color="white">play_arrow</v-icon>
                                </div>
                                <div class="text-thumb" v-if="content.type === 2">
                                  <v-icon color="white">text_fields</v-icon>
                                </div>
                              </div>

                              <v-btn class="plus-btn" dark fab small color="orange" v-if="content.pdf"
                                     @click="downloadPDF(content.pdf)" :loading="loadingPDF[content.pdf]">
                                <v-icon>picture_as_pdf</v-icon>
                              </v-btn>

                              <v-btn class="edit-btn" dark fab small color="blue" @click="showDialogEdit($index)">
                                <v-icon>edit</v-icon>
                              </v-btn>

                              <v-btn class="delete-btn" dark fab small color="red" @click="deleteContent($index)">
                                <v-icon>delete</v-icon>
                              </v-btn>

                              <v-card-title primary-title class="pb-0">
                                <h3>{{ content.title }}</h3>
                              </v-card-title>

                              <v-card-text>
                                <div>Ordem de exibição: {{ (content.position + 1) }}</div>
                                <div v-if="content.startAt">Data de início: {{
                                    content.startAt | formatDateContent
                                  }}
                                </div>
                              </v-card-text>
                            </v-card>

                          </v-badge>
                        </v-col>

                      </draggable>

                    </div>
                  </v-card-text>

                </v-card>
              </div>
            </v-col>
            <v-col cols="12" sm="12">

            </v-col>
          </v-row>

          <modal-video v-if="dialogEditVideo" v-model="dialogEditVideo" :content="contentEdit"
                       @save="saveContent"></modal-video>
          <modal-text v-if="dialogContentText" v-model="dialogContentText" :content="contentEdit"
                      @save="saveContent"></modal-text>
        </v-card-text>
        <v-card-actions>
          <v-btn color="green" dark :to="{name:'course-create-step2', params: {courseId}}" class="mt-3 ml-0">Voltar
          </v-btn>
          <v-divider></v-divider>
          <v-btn color="green" dark @click="next" class="mt-3 ml-0">
            Avançar
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </user-course-register>
</template>
<script>
import UserCourseRegister from '@/views/User/CourseRegister'
import ModalVideo from '@/views/User/CourseRegister/ModalVideo'
import ModalText from '@/views/User/CourseRegister/ModalText'
import draggable from 'vuedraggable'

export default {
  name: 'UserCourseRegisterStep3',
  components: {
    UserCourseRegister,
    ModalVideo,
    ModalText,
    draggable,
  },
  data: () => {
    return {
      dialogContentText: false,
      dialogEditVideo: false,
      moduleSelect: null,
      contentsLocal: [],
      modules: [],
      moduleId: null,
      moduleTitle: null,
      indexContentEdit: -1,
      contentEdit: {
        startAt: new Date().toISOString()
      },
      draggableOptions: {
        disabled: false,
        cursor: 'grab'
      },
      loadingContent: false,
      loadingModules: false,
      loadingPDF: {},
    }
  },
  computed: {
    courseId: function () {
      return this.$route.params.courseId
    },
    courseHasModules () {
      return !!this.modules.length
    },
  },
  created () {
    this.getModulesWithContents()
  },
  methods: {
    getModulesWithContents () {
      this.loadingModules = true
      this.axios.get(`/user/course/modules/contents/${this.courseId}`).then(response => {
        if (response.data.success) {
          this.modules = response.data.modules
          this.contentsLocal = response.data.contents
        }
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.loadingModules = false
      })
    },
    downloadPDF (pdf) {
      this.loadingPDF[pdf] = true
      this.axios.request({
        method: 'get',
        url: `/user/content/file/${pdf}`,
        responseType: 'blob'
      }).then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${pdf}.pdf`)
        document.body.appendChild(link)
        link.click()
      }).finally(() => {
        this.loadingPDF[pdf] = false
      })
    },
    deleteContent (index) {
      let content = this.contentsLocal[index]

      if (content._id) {
        this.$swal({
          title: 'Confirma a exclusão do conteúdo?',
          text: 'Essa ação não poderá ser desfeita',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#cf3034',
          cancelButtonColor: '#0077bd',
          confirmButtonText: 'Confirmar exclusão',
          cancelButtonText: 'Cancelar'
        }).then(result => {
          if (result.value) {
            this.axios.delete(`/user/content/${content._id}`).then(({ data }) => {
              if (data.success) {
                this.contentsLocal.splice(index, 1)

                this.updateContentPosition()
              }
            })
          }
        })
      } else {
        this.contentsLocal.splice(index, 1)
        this.updateContentPosition()
      }
    },

    selectModule (moduleId) {
      if (moduleId === this.moduleId) {
        this.moduleId = null
        this.contentsLocal = []

        return false
      }

      this.loadingContent = true

      this.moduleId = moduleId
      this.moduleTitle = this.modules.find(m => m._id === moduleId).title

      this.axios.get(`/user/content/module/${moduleId}`).then(({ data }) => {
        if (data.success) {
          this.contentsLocal = data.contents
        }
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.loadingContent = false
      })
    },
    updateContentPosition () {
      this.draggableOptions.disabled = true
      let k = 0
      for (let i = 0; i < this.contentsLocal.length; i++) {
        this.contentsLocal[i].position = k
        k++
      }

      const dataOrder = this.contentsLocal.map(content => {
        return {
          _id: content._id,
          position: content.position,
        }
      })

      this.axios.put('/user/content/order', dataOrder).then(({ data }) => {
        if (!data.success) {
          this.$swal('Ops', data.message, 'error')
        }
      }).catch(err => {
        console.error(err)
        this.$swal('Ops', 'Houve um erro ao atualizar a ordem dos conteúdos', 'error')
      }).finally(() => {
        this.draggableOptions.disabled = false
      })
    },
    getContentPosition () {
      return this.contentsLocal.length
    },
    onUpdate () {
      this.updateContentPosition()
    },
    onEnd () {
      // this.draggableOptions.disabled = true
    },
    showDialogEdit (indexContent) {
      this.updateContentPosition()

      this.indexContentEdit = indexContent

      this.contentEdit = { ...this.contentsLocal[indexContent] }

      if (!this.contentsLocal[indexContent].pdfFile) {
        this.contentEdit.pdfFile = null
      }

      if (this.contentEdit.type === 2) {
        this.dialogContentText = true
      }

      if (this.contentEdit.type === 1) {
        this.dialogEditVideo = true
      }
    },
    addContent (type) {
      this.indexContentEdit = -1

      this.contentEdit = {
        position: this.getContentPosition(),
        startAt: new Date().toISOString().substr(0, 10),
        pdfFile: null
      }

      if (this.moduleId) {
        this.contentEdit.module = this.moduleId
      } else {
        this.contentEdit.course = this.courseId
      }

      if (type === 2) {
        this.dialogContentText = true
      }

      if (type === 1) {
        this.dialogEditVideo = true
      }
    },

    // cancelContentText () {
    //   this.dialogContentText = false
    //   this.contentDescription = ''
    //   this.contentTitle = ''
    //   this.indexContentEdit = -1
    // },

    saveContent (content) {
      // editando
      if (this.indexContentEdit !== -1) {
        this.contentsLocal[this.indexContentEdit] = content

        this.indexContentEdit = -1
      } else {
        this.contentsLocal.push(content)
      }

      // this.dialogContentText = false
    },
    next () {
      if (!this.contentsLocal.length && this.moduleId) {
        let message = 'Insira o conteúdo para o Curso'

        if (this.moduleTitle) {
          message = `Insira o conteúdo para o módulo ${this.moduleTitle}`
        }

        this.$swal('Ops', message, 'error')

        return false
      }

      this.$router.push({ name: 'course-create-step4', params: { courseId: this.courseId } })
    }
  }
}
</script>
<style scoped>
.move {
  cursor: move;
}
</style>
